import React from 'react';
import { Card } from 'semantic-ui-react';
import './Name.css';
export default function Name(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement(Card.Header, {
    className: "name"
  }, name);
}